import { isPlatformServer } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';

export const AdminModalSizeOptions = {
  maxWidth: '1024px',
  height: '100%',
  maxHeight: '700px',
};

export const HTTP_REQUESTS_TIMEOUT = 60 * 30 * 1000;
export const IS_SERVER_PLATFORM = new InjectionToken<boolean>('Is server?', {
  factory() {
    return isPlatformServer(inject(PLATFORM_ID));
  },
});
